<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="customer" label="Konsumen">
                      <vue-autosuggest
                          v-model="customers.text"
                          @inputout="focusMe"

                          :suggestions="filteredOptions"
                          @input="onInputChange"
                          @selected="onSelected"
                          :input-props="{ id: 'customer', placeholder: 'Find Customer', class: 'form-control'}"
                          :limit="20"
                        >
                          <template slot-scope="{ suggestion }">
                            <span class="my-suggestion-item"> 
                              {{ suggestion.item.text }}
                            </span>
                          </template>
                        </vue-autosuggest>


                    <!-- <model-select
                      id="customer"
                      :options="listCustomer"
                      v-model="findCustomer"
                      placeholder="Konsumen"
                    ></model-select> -->
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group label-for="limit" label="Jumlah Data Terakhir Yang Ingin Di Tampilkan">
                   <model-select
                      id="limit"
                      :options="listLimit"
                      v-model="limitVal"
                      placeholder="Konsumen"
                    ></model-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <b-button
                    size="sm"
                    variant="stack-overflow"
                    class="mr-1 btn-brand"
                    @click="findProcess"
                  >
                    <i class="fa fa-search"></i>
                    <span>Filter</span>
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template v-if="!loading">
              <h5>{{valCust}}</h5>
              <table class="rekap-ro table-bordered table-responsive">
                <thead>
                  <tr>
                    <th class="width-250">Order Number</th>
                    <th class="width-250">Tanggal Input Order</th>
                    <th class="width-250">Rencana Tanggal Kiriman</th>
                    <th class="width-250">SPKB Number</th>
                    <th class="width-250">Status</th>
                    <th class="width-250">Deskripsi</th>
                  </tr>
                </thead>

                <tbody v-if="customerHistory.length > 0">
                  <template v-for="(v, index) in customerHistory">
                    <tr :key="uniqueId(index+'B')">
                      <td>{{v.order_number}}</td>
                      <td>{{v.date_order}}</td>
                      <td>{{v.plan_delivery_order}}</td>
                      <td>{{v.spkb_number}}</td>
                      <td>{{v.status_spkb}}</td>
                      <td>{{v.description}}</td>
                    </tr>
                  </template>
                </tbody>

                <tbody v-else>
                    <tr>
                        <td :colspan="6">No data</td>
                    </tr>
                </tbody>
              </table>
            </template>
            <loading v-else></loading>

          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";
import globalTable from "../../templates/Table.vue";
import loading from "@/templates/Loading.vue";
import { VueAutosuggest } from 'vue-autosuggest';

import _ from "lodash";
export default {
  name: "customer-tracking-order",
  components: {
    globalTable,
    ModelSelect,
    loading,
    VueAutosuggest
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      listLimit: [],
      limitVal: '40',
      valCust: null,
      loading: false,
      customerHistory: [],
      customers: {
        text: null,
        value: null
      },
      filteredOptions: [],
      suggestions: [
        {
          data: [],
        },
      ]
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  computed: {},
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    init: function() {
      this.loading = false;
      this.getDropdown();
    },
    getDropdown: function() {
      this.listLimit = [
        {value: '20', text: '20'},
        {value: '40', text: '40'},
        {value: '60', text: '60'},
        {value: '80', text: '80'},
        {value: '100', text: '100'},

      ]
      // this.axios
      //   .get("web/dropdown/customer/")
      //   .then(response => {
      //     this.listCustomer = response.data.data;
      //   })
      //   .catch(error => {
      //     if (error.response.status === 401) {
      //       this.expired(error, "");
      //     }
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    expired: function(error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: "Tambah Konsumen",
          message: error.response.data.message
        });
      }
    },
    findProcess: function() {
      this.loading = true;

      this.axios
        .get(
          "web/customer/cro-customer-detail/" + this.customers.value + "/"+this.limitVal+"/"
        )
        .then(response => {
          this.valCust = this.customers.text;
          this.customerHistory = response.data.myOrder;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading = false;
          this.customers.value = null;
          this.customers.text = null;
          this.filteredOptions= [];
          this.suggestions = [
            {
              data: [],
            }
          ];
        });
    },
    onSelected(item) {
      if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        this.customers.value = item.item.value;
        this.customers.text = item.item.text;
     }
    },
    focusMe: function(item){
       if (item === "" || item === undefined || item === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      }
    },
    onInputChange(text) {
      if (text === "" || text === undefined || text === null) {
        this.customers.value = null;
        this.customers.text = null;
        return;
      } else {
        axios
          .post("web/dropdown/find-customer/", {'name':text})
          .then((response) => {
            this.dropdown_customer = response.data.data;
            this.suggestions[0].data = this.dropdown_customer;
            const filteredData = this.suggestions[0].data;
            this.filteredOptions = [
              {
                data: filteredData,
              },
            ];
          })
          .catch((error) => {})
          .finally(() => {});
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
.demo { 
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
 
input {
  width: 260px;
  padding: 0.5rem;
}
 
.autosuggest__results > ul {
  width: 100%;
  color: rgba(30, 39, 46,1.0);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 .5rem 0;
}
.autosuggest__results > ul > li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}
.autosuggest__results > ul > li:hover {
  cursor: pointer;
}
 
.autosuggest-container {
  display: flex;
  justify-content: center;
  width: 280px;
}
 
#autosuggest { width: 100%; display: block;}
.autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178,0.2);
}
#autosuggest__input {
      outline: none;
      position: relative;
      display: block;
      font-family: monospace;
      font-size: 20px;
      border: 1px solid #616161;
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
    }
    
    #autosuggest__input.autosuggest__input-open {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    
    .autosuggest__results-container {
      position: relative;
      width: 100%;
    }
    
    .autosuggest__results {
      font-weight: 300;
      margin: 0;
      position: absolute;
      z-index: 10000001;
      width: 100%;
      border: 1px solid #e0e0e0;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      background: white;
      padding: 0px;
      overflow: scroll;
      max-height: 200px;
    }
    
    .autosuggest__results ul {
      list-style: none;
      padding-left: 0;
      margin: 0;
    }
    
    .autosuggest__results .autosuggest__results_item {
      cursor: pointer;
      padding: 15px;
    }
    
    #autosuggest ul:nth-child(1) > .autosuggest__results_title {
      border-top: none;
    }
    
    .autosuggest__results .autosuggest__results_title {
      color: gray;
      font-size: 11px;
      margin-left: 0;
      padding: 15px 13px 5px;
      border-top: 1px solid lightgray;
    }
    
    .autosuggest__results .autosuggest__results_item:active,
    .autosuggest__results .autosuggest__results_item:hover,
    .autosuggest__results .autosuggest__results_item:focus,
    .autosuggest__results .autosuggest__results_item.autosuggest__results_item-highlighted {
      background-color: #b6adad;
    }
</style>